import { useContext, forwardRef, useState } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';
import { useTranslation } from 'react-i18next';
import { ConfigProvider, Form } from "antd";
import { Typography, Button, Input } from 'mobily-ui-library';
import './TwoYearCoverageLogin.scss';

interface Props {
    handleHeaderCancel: () => void;
}

const TwoYearCoverageLogin = forwardRef((props: Props) => {
    const { handleHeaderCancel } = props;
    const { state, dispatch }: any = useContext(GlobalContext);
    const [mobileValid, setMobileValid] = useState(false);
    const [mobileNumber, setMobileNumber] = useState('05');
    const [mobileNumberColor, setMobileNumberColor] = useState('blue');
    const { rtl } = state;
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const direction = rtl ? 'rtl' : 'ltr';

    const handleMobileNumber = (e: any) => {
        const value = e.target.value;
        let newValue = value;
        if (newValue.indexOf('05') != 0) {
            newValue = '05'
        }
        form.setFieldsValue({
            mobileNumber: newValue
        });
        setMobileNumber(newValue);
        const regex = /^((05)([0-9]{8}))$/;
        if (regex.test(value)) {
            setMobileValid(true);
        } else {
            setMobileValid(false);
        }
    }

    const focusHandelMobileNumber = () => {
        if (!mobileNumber) {
            form.setFieldsValue({
                mobileNumber: '05'
            });
        }
        setMobileNumberColor('blue');
    }

    const focusOutHandelMobileNumber = () => {
        if (mobileNumber.length > 2) {
            const pattern = /^(((05)(5|0|3|6|4|9|1|8|7|2)([0-9]{7})))$/
            const result = pattern.test(mobileNumber);
            if (result) {
                setMobileNumberColor('blue');
            }
            else {
                setMobileNumberColor('red');
            }
        } else {
            setMobileNumberColor('blue');
        }
    }


    const handleSubmit = () => {
        dispatch({ type: 'DEVICE_MOBILENUMBER', payload: { msisdn: mobileNumber } });
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "TermsOTP" } });
        dispatch({ type: "LOADER", payload: { loading: true } });
    }

    return (
        <div className="container AppleCare__Container">
            <HeaderNavigation
                rtl={rtl}
                percent={25}
                showBackArrow={false}
                handleHeaderCancel={handleHeaderCancel}
            />
            <section className='SubsidyLogin__Section'>
                <div className='SL__headerText'>
                    <Typography id="sl-heading" rtl={rtl} className='SL__heading'>{t('Applecare_plus_coverage_subscription')}</Typography>
                    <Typography id="sl-Subheading" rtl={rtl} className='SL__subHeading'>{t('Subtitle_if_required_goes_here')}</Typography>
                </div>
                <ConfigProvider direction={direction}>
                    <Form form={form} className={rtl ? "SL__Form SL__right" : "SL__Form"} onFinish={handleSubmit}>
                        <Form.Item
                            hasFeedback
                            name='mobileNumber'
                            initialValue={mobileNumber}
                            className={`loginType_mobileNum_text_color-${mobileNumberColor}`}
                            rules={[
                                { required: true, message: t('Receiver_Phone_Number_is_Missing') },
                                {
                                    message: t('Not_a_Valid_Phone_Number'),
                                    pattern: /^((05)([0-9]{8}))$/
                                }
                            ]}
                        >
                            <Input
                                type="text"
                                maxLength={10}
                                value={mobileNumber}
                                id="mobilyNumber-input"
                                className="SL__FormInput"
                                headingleft={t('Enter_number')}
                                labelleft={t('The_line_should_be_active_to_receive_SMS')}

                                onChange={handleMobileNumber}
                                onFocus={focusHandelMobileNumber}
                                onBlur={focusOutHandelMobileNumber}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                rtl={rtl}
                                id="login-button"
                                className="SL_FormBtn"
                                htmlType={'submit'}
                                variant={mobileValid ? "default" : "disabled"}
                            >
                                {t('Continue')}
                            </Button>
                        </Form.Item>
                    </Form>
                </ConfigProvider>
            </section>
        </div>
    )
})

export default TwoYearCoverageLogin
